import script from "./budget-manual-action.vue?vue&type=script&setup=true&lang=ts"
export * from "./budget-manual-action.vue?vue&type=script&setup=true&lang=ts"

import "./budget-manual-action.vue?vue&type=style&index=0&id=4dc56913&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc56913"]])

export default __exports__